<template>
  <v-card
    elevation="0"
    class="rounded-lg pa-0 w-100 h-100"
    style="overflow-y: auto"
  >
    <v-card-title class="px-3 py-2 d-flex justify-space-between">
      <h5 class="text-caption mr-1 font-weight-bold">Item Details</h5>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
      <v-row no-gutters>
        <v-col
          cols="6"
          class="d-flex mb-4"
          v-for="(itemDetail, itemDetailIndex) in dataObj.storage_type_stats"
          :key="itemDetailIndex"
        >
          <v-btn small class="h-100 mr-3 primary--text btn-box" depressed>
            <v-icon :color="itemDetail.color" small>mdi-checkbox-blank</v-icon>
          </v-btn>
          <div class="mr-2">
            <span class="text-caption text-capitalize text_color--text">{{
              itemDetail.name
            }}</span>
            <h5>{{ itemDetail.count }}</h5>
          </div>
        </v-col>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import BoxIconWithText from "@/components/BaseComponents/BoxIconWithText.vue";
export default {
  components: {
    BoxIconWithText,
  },
  props: {
    dataObj: {
      required: true,
    },
  },
};
</script>
